import {cpf, cpfOrCnpj, InputType, Schema} from 'simpli-web-sdk'
import DeliveryShipperRequest from '@/model/request/DeliveryShipperRequest'

export default (model: DeliveryShipperRequest): Schema => ({
  nome: {
    content: model.nome,
  },

  cpfCnpj: {
    content: model.cpfCnpj && model.cpfCnpj.$tag,
  },

  mes: {
    content: model.mes,
  },
})
